import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';
import styles from "./trust-pilot.module.css";
import { color } from 'framer-motion';
import { Link } from 'react-router-dom';

const TrustPilot = () => {
    const paymentChannels = [
        { name: 'UPI', icon: './upi.png', color: '#FF6B35' },
        { name: 'PhonePe', icon: './phonepe.png', color: '#5F259F' },
        { name: 'GPay', icon: './gpay.png', color: '#4285F4' },
        { name: 'Paytm', icon: './paytm.png', color: '#00BAF2' },
    ];

    const features = [
        '100% Secure Transactions',
        'Instant Delivery on Most Orders',
        'Affordable Pricing & Exclusive Offers',
        'Trusted by Thousands of Gamers'
    ];

    return (
        <div className={styles.container}>
            {/* Hero Section with Curved Image */}
            <div className={styles.heroSection}>
                <img
                    src="./trustpilot.png"
                    alt="Gaming Collage"
                    className={styles.heroImage}
                />
                <div className={styles.heroOverlay}></div>
            </div>

            {/* Store Title */}
            <div className={styles.storeTitle}>
                <div className={styles.storeTitleBadge}>
                    <h1 className={styles.storeTitleText}>PixelMoon Store</h1>
                </div>
            </div>

            {/* Why Choose Us Section */}
            <div className={styles.whyChooseSection}>
                <div className={styles.card}>
                    <h2 className={styles.sectionTitle}>
                        <span className={styles.Star}>
                            <svg width="36" height="36" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg">
                            <polygon
                                points="
                                28,16
                                21,18
                                22.5,25.5
                                16.2,21.5
                                11.5,27.2
                                12.8,20.3
                                6,17.5
                                10.2,14.3
                                9.5,7.5
                                15.8,11
                                22.4,6.8
                                21.8,13.5
                                27,15.5
                                "
                            />
                            </svg>
                        </span>
                        <span className={styles.Text}>Why choose us?</span>
                    </h2>

                    <div className={styles.featureList}>
                        {features.map((feature, index) => (
                            <div key={index} className={styles.featureItem}>
                                <div className={styles.checkmark}>
                                    <span className={styles.checkmarkIcon}>✓</span>
                                </div>
                                <p className={styles.featureText}>{feature}</p>
                            </div>
                        ))}
                    </div>

                </div>
                <p className={styles.description}>
                    We bring gamers the best deals, exclusive skins, and premium in-game items for titles like MLBB, PUBG, BGMI, Genshin Impact and more! Safe, fast, and affordable.
                </p>
            </div>

            {/* Payment Channels */}
            <div className={styles.paymentSection}>
                <h3 className={styles.paymentTitle}>Payment Channels</h3>
                <div className={styles.paymentCarousel}>
                    <div className={styles.paymentTrack}>
                        {paymentChannels.map((channel, index) => (
                            <div 
                                key={index} 
                                className={styles.paymentChannel}
                                style={{border: `5px solid ${channel.color}`}}
                            >
                                <div className={styles.paymentChannelImg}>
                                    <img src={channel.icon} alt={channel.name} />
                                </div>
                            </div>
                        ))}
                    </div>
                    <div aria-hidden className={styles.paymentTrack}>
                        {paymentChannels.map((channel, index) => (
                            <div 
                                key={index} 
                                className={styles.paymentChannel}
                                style={{border: `5px solid ${channel.color}`}}
                            >
                                <div className={styles.paymentChannelImg}>
                                    <img src={channel.icon} alt={channel.name} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Trustpilot Section */}
            <div className={styles.trustpilotSection}>
                <a href="https://www.trustpilot.com/review/pixelmoonstore.in" target="_blank" rel="noopener" className={styles.trustpilotCard}>
                    <span className={styles.trustpilotText}>Review us on</span>
                    <Star style={{ width: '1.25rem', height: '1.25rem', fill: '#22c55e', color: '#22c55e' }} />
                    <span className={styles.trustpilotBrand}>Trustpilot</span>
                </a>
            </div>

            {/* Customer Support */}
            <div className={styles.supportSection}>
                <div className={styles.card}>
                    <h3 className={styles.supportTitle}>CUSTOMER SUPPORT</h3>
                    <p className={styles.supportText}>
                        If you need any help, please contact us by clicking "Customer Service" to get in touch with us.
                    </p>
                    <a 
                        href="https://wa.link/oskfd2" 
                        target="_blank" 
                        rel= "noreferrer" 
                        className={styles.supportButton}
                    >
                        <span>Customer Service</span>
                        <span className={styles.supportButtonArrow}>↗</span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default TrustPilot;